import { GridItem } from '@calendly/ui/components/grid'

export const RightColumn = ({ children }) => (
  <GridItem size="9" sizeMobile="12">
    {children}
  </GridItem>
)
